import {Matcher} from '@/lib/axiosAddTransforms'
import {
  transactionDateResponse,
  payResponse,
  orderRequest,
  offsetResponse,
  payDateResponse,
} from '@/transformers/utils'

const matchers: Matcher[] = [
  {
    test: /^\/taxes\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {order} = payload.params
        const {bizId} = payload.data
        payload.url = `/bizs/${bizId}/transactions/`
        payload.params.o = orderRequest(order)
        payload.params.status = payload.params.status.join(',')
        delete payload.params.order
        return payload
      },
      response: (data) => {
        if(!data || !data.results) {
          return {}
        }
        return {
          results: data.results.map((result) => taxListResponse(result)),
          ...propertyResponse(data),
        }

      },
    },
  },
  {
    test: /^\/taxes\/\$id\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {id, bizId} = payload.data
        payload.url = `/bizs/${bizId}/transactions/${id}`
        return payload
      },
      response: (data) => {
        if(!data || !data.id) {
          return data
        }
        return taxResponse(data)
      },
    },
  },
  {
    test: /^\/register-payment\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {taxIds, bizId, bank, password} = payload.data
        payload.url = `/bizs/${bizId}/transactions/payments`
        payload.data = {
          transactions: taxIds,
          bankAccount: bank,
          bankAccountPassword: password,
        }
        return payload
      },
      response: (data) => {
        if(!data) {
          return data
        }
        return paymentResponse(data)
      },
    },
  },
  {
    test: /^\/taxes\/\$id\/status?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        const {id, bizId} = payload.data
        payload.url = `/bizs/${bizId}/transactions/${id}/status`
        delete payload.data.id
        delete payload.data.bizId
        return payload
      },
      response: (data) => {
        if(!data || !data.id) {
          return data
        }
        return taxResponse(data)
      },
    },
  },
  {
    test: /^\/taxes\/summary/,
    method: 'get',
    transform: {
      request: (payload) => {
        const {bizId} = payload.params
        payload.url = `/bizs/${bizId}/transactions/summary`
        delete payload.params.bizId
        return payload
      },
      response: (data) => {
        if(!data) {
          return data
        }
        return data
      },
    },
  },
]

const taxResponse = (data) => {
  const {
    id, bizBankAccount, dueDate, errorCode,
    paidAt, isForcedPayment, client, sharedData,
  } = data
  const {rawData} = data.virtualEvidences[0]
  const taxType = client.name
  const rawDataResponse = taxType === '국세' ?
    nationalTaxResponse(rawData) : localTaxResponse(rawData)
  return {
    id: String(id),
    status: statusResponse(data),
    dueDate: transactionDateResponse(dueDate),
    errorMessage: errorCode,
    code: bizBankAccount.bankCode,
    accountNumber: bizBankAccount.number,
    transferDate: transactionDateResponse(paidAt),
    isForcedPayment,
    taxType,
    amount: payResponse(sharedData.amountTotal),
    ...rawDataResponse,
  }
}

const nationalTaxResponse = (rawData) => {
  const {
    taxNm, payerNm, billOrgNm, epayNo,
    bizNo, payAmt1, payAmt2, payDate1, payDate2,
  } = rawData
  return {
    taxNm,
    payerNm,
    epayNo,
    billOrgNm,
    bizNo,
    payAmt1: payResponse(payAmt1),
    payAmt2: payResponse(payAmt2),
    payDate1: payDateResponse(payDate1),
    payDate2: payDateResponse(payDate2),
  }
}

const localTaxResponse = (rawData) => {
  const {
    taxNm, payerNm, billOrgNm, epayNo,
    taxYm, tax1, tax2, tax3, tax4, taxSum, taxBase,
  } = rawData
  return {
    taxNm,
    payerNm,
    epayNo,
    billOrgNm,
    taxYm,
    tax1: payResponse(tax1),
    tax2: payResponse(tax2),
    tax3: payResponse(tax3),
    tax4: payResponse(tax4),
    taxSum: payResponse(taxSum),
    taxBase: payResponse(taxBase),
  }
}

const taxListResponse = (data) => {
  const {
    id, errorCode, dueDate, client, paidAt,
    sharedData, bizBankAccount, isForcedPayment
  } = data
  return {
    id: String(id),
    title: sharedData.mainItemName,
    status: statusResponse(data),
    amount: payResponse(sharedData.amountTotal),
    dueDate: transactionDateResponse(dueDate),
    agency: client.name,
    errorMessage: errorCode,
    paymentNumber: null,
    accountNumber: bizBankAccount,
    transferDate: transactionDateResponse(paidAt),
    isForcedPayment,
  }
}

const paymentResponse = (data) => {
  return {
    data,
  }
}

const propertyResponse = (data) => {
  const {next, count} = data
  return {
    nextOffset: offsetResponse(next),
    count,
  }
}

const statusResponse = (data) => {
  const {status, isExcluded} = data
  // make excluded status
  if(status === 'completed' && isExcluded) {
    return 'excluded'
  }
  return status
}

export {payDateResponse}

export default matchers
